import { render } from "./BaseCheckbox.vue?vue&type=template&id=7c11ca6c"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"
script.render = render

export default script